import React from 'react'

export const SectionApp2 = () => {


    return (
       <div className="sectionapp2">
            <div className="">
                <div className="cover">
                    <img src="/assets/images/bg/phone2.png" className="" draggable="false" alt="" />
                </div>
                <div className="introduce">
                <div>
                        <h1 className="title"> Fully Responsive for all of the platforms</h1>
                        <p className="description">
                        
 Such as smart phones, tablets pc/mac notebook or desktop devices. 
Well documented so, docs will help you to understand the theme generally.  
                        </p>
                        <div className="store">
                           <a href="##" target='_blank'> <div className="app primary">Let's get started</div></a>
                            <div className="app">More</div>
                        </div>
                </div>
                </div>
            </div>
            <div className="">

            </div>
       </div>
    )
} 


